const splitProps = (props, keys) => {
  const picked = {};
  const omitted = { ...props };
  if (typeof keys === "function") {
    for (const key in props) {
      if (keys(key)) {
        picked[key] = props[key];
        delete omitted[key];
      }
    }
  } else {
    for (const key of keys) {
      picked[key] = props[key];
      delete omitted[key];
    }
  }
  return [picked, omitted];
};
const createSplitProps = (keys) => {
  return function split(props) {
    return splitProps(props, keys);
  };
};

export { createSplitProps, splitProps };
